import apiSlice from '../api/api.slice';
import {
  ICommentWithUser,
  IComment,
  ICreateCommentRequest,
  IDeleteCommentRequest,
} from './comment';

export const commentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getComments: builder.query<ICommentWithUser[], string>({
      query: (postId) => ({
        url: `/api/v1/comment/getCommentsByPostId/${postId}`,
        method: 'GET',
      }),
      transformResponse: (response: { comments: ICommentWithUser[] }) =>
        response.comments,
    }),
    createComment: builder.mutation<IComment, ICreateCommentRequest>({
      query: ({ postId, comment }) => ({
        url: `/api/v1/comment/create`,
        method: 'POST',
        body: {
          postId,
          comment,
        },
      }),
      transformResponse: (response: { comment: IComment }) => response.comment,
    }),
    deleteComment: builder.mutation<IComment, IDeleteCommentRequest>({
      query: (params) => ({
        url: `/api/v1/comment/delete`,
        method: 'DELETE',
        params,
      }),
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['Comment'],
  endpoints: {
    getComments: {
      providesTags: ['Comment'],
    },
    createComment: {
      invalidatesTags: ['Comment', 'Post'],
    },
    deleteComment: {
      invalidatesTags: ['Comment', 'Post'],
    },
  },
});

export const {
  useGetCommentsQuery,
  useCreateCommentMutation,
  useDeleteCommentMutation,
} = commentApiSlice;
